import MetaTag from "components/Common/Meta-tag"
import React, { useEffect } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import { Container } from "reactstrap"
import Form from "./Form"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom/cjs/react-router-dom.min"
import { getInspectionBookingDetails } from "store/actions"

function UpdateInspectionBooking() {
  const dispatch = useDispatch()
  const params = useParams()

  useEffect(() => {
    dispatch(getInspectionBookingDetails(params.id))
  }, [params.id])

  const bookingDetails = useSelector(
    state => state.Inspection.inspectionBookingDetails
  )

  return (
    <div>
      <MetaTag title={"Update Booking"} />

      <div className="page-content">
        <Breadcrumbs
          title="Dashboard / Inspection"
          breadcrumbItem="Update Booking"
        />
        <Container fluid>
          <Form updateData={bookingDetails} />
        </Container>
      </div>
    </div>
  )
}

export default UpdateInspectionBooking
